import authrequest from '@/utils/authrequest'

// HIS 患者列表查询
export function hisListPatients(params) {
  return authrequest({
    url: '/api/app/patient',
    method: 'get',
    params
  })
}

// HIS 患者列表查询
export function hisGetPatients(id) {
  return authrequest({
    url: '/api/app/patient/' + id,
    method: 'get' 
  })
}

// HIS 新增患者
export function hisCreatePatient(data) {
  return authrequest({
    url: '/api/app/patient',
    method: 'post',
    data
  })
}

// HIS 更新患者
export function hisUpdatePatient(id, data) {
  return authrequest({
    url: `/api/app/patient/${id}`,
    method: 'put',
    data
  })
}

// HIS 删除患者
export function hisDeletePatient(id) {
  return authrequest({
    url: `/api/app/patient/${id}`,
    method: 'delete'
  })
}

// HIS 归档患者（归档后患者默认不在列表中展示，数据保留）
export function hisArchivePatient(id) {
  return authrequest({
    url: `/api/app/patient/${id}/archive`,
    method: 'post'
  })
}

// HIS 取消归档患者（恢复为正常状态）
export function hisUnarchivePatient(id) {
  return authrequest({
    url: `/api/app/patient/${id}/unarchive`,
    method: 'post'
  })
}

// HIS 导出患者列表
export function hisExportPatients(data) {
  return authrequest({
    url: '/api/app/patient/export',
    method: 'post',
    data,
    responseType: 'blob'
  })
}

// 获取班次下拉选项（全量唯一值）
export function hisGetScheduleClassOptions() {
  return authrequest({
    url: '/api/app/patient/schedule-class-options',
    method: 'get'
  })
}

// 获取区域下拉选项（全量唯一值）
export function hisGetAreaNameOptions() {
  return authrequest({
    url: '/api/app/patient/hdis-area-name-options',
    method: 'get'
  })
}

// 从 HDIS 批量同步患者信息
export function hisSyncFromHdis(data) {
  return authrequest({
    url: '/api/app/patient/sync-from-hdis',
    method: 'post',
    data
  })
}

// 获取最晚的排班同步时间
export function hisGetLatestScheduleSyncTime() {
  return authrequest({
    url: '/api/app/patient/latest-schedule-sync-time',
    method: 'get'
  })
}

// 判断是否应该同步排班（距上次同步超过1小时且无同步任务进行中时返回 true）
export function hisShouldSyncSchedule() {
  return authrequest({
    url: '/api/app/patient/should-sync-schedule',
    method: 'post'
  })
}

